module.exports = __webpack_public_path__ + "static/media/ballot.fd8808d0.svg";